import React from 'react';

import { Page } from 'ui/components/Page/Page';
import { Routes } from '../../navigation';
import LabelDesigner from './components/LabelDesigner';

export interface TemplatesPageProps {}

interface TemplatesPageComponent extends React.FC<TemplatesPageProps> {
  route: string;
}

const TemplatesPage: TemplatesPageComponent = () => {
  return (
    <Page
      margin="-16px"
      width="calc(100% + 32px);"
      height="calc(100% + 32px);"
      border="none"
    >
      <LabelDesigner />
    </Page>
  );
};

TemplatesPage.route = Routes.TemplatesPage;

export default TemplatesPage;
